import { EventDispatch } from './event-dispatch';

export class ComponentBase extends EventDispatch {
  protected Enable = true;

  disable() {
    this.Enable = false;
  }

  enable() {
    this.Enable = true;
  }

  isEnabled() {
    return this.Enable;
  }
}



// WEBPACK FOOTER //
// ./src/app/component-base.ts